/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import { BigButtons } from "./BigButtons";
import { CircularProgress } from "@mui/material";
import { ErrorMessage, FilterableListController } from "./VideosList";
import { usePlayerData } from "../usePlayerData";
import { FilterByGroup } from "../pages/CategoryRender";

export const BigCategoriesList = (props: {
	name: string;
	groupFilter: FilterByGroup;
	suffix?: React.ReactNode;
}) => {
	const navigate = useNavigate();
	const playerData = usePlayerData();

	if (playerData.query.isLoading) {
		return <CircularProgress />;
	}

	if (playerData.query.isError) {
		return <div>Erro ao carregar dados do player</div>;
	}

	const currentGroup = playerData.queryGroupBy({ id: props.groupFilter.groupId, name: props.groupFilter.groupName });

	if (!currentGroup) {
		return (
			<ErrorMessage message={`Grupo não encontrado: ${props.groupFilter.groupName}`} />
		);
	}

	return (
		<FilterableListController
			groupFilter={props.groupFilter}
			breadcrumb={[props.name]}
		>
			<BigButtons
				suffix={props.suffix}
				buttons={currentGroup.categories.map((channel) => {
					return {
						label: channel.name,
						backgroundUrl: channel.bgImage.url,
						onClick() {
							navigate(`${channel.id}`);
						},
					};
				})}
			/>
		</FilterableListController>
	);
};
